module.exports = __webpack_public_path__ + "static/wash_sec2_obj2M@2x-111da82edd04070a7d200f02884270a1.png";